module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/130-sicily-d57d6654f1dc59f08ce0539252ea01ff.svg";